import React, {PureComponent} from 'react';

import Form from 'components/Form';
import Input from 'components/Input';
import Loader from 'components/Loader';
import Button from 'components/Button';
import {Link} from 'react-router-dom';
import {getBrand} from '../../utils';

import emailIcon from 'components/Login/email-icon.svg';

import './reset-password.css';

export default class ResetPasswordView extends PureComponent{
    render(){
        return (
            <section className="cl-reset">
                <Form onSubmit={this.props.onSubmit} className="cl-login-form">
                    <h1>Reset your password</h1>
                    <Input required icon={emailIcon} placeholder="Email" value={this.props.email} name="email" onChange={this.props.onChange}/>
                    <Button disabled={this.props.loading} className="cl-login-submit" type="submit" styling={getBrand() === 'circleloop' ? 'turquoise' : 'cloudtalk'}>
                        <span>Reset Password</span>
                        {this.props.loading ? <Loader type="1" size="16px"/> : null}
                    </Button>
                    <div className="cl-reset-links row between-xs no-margin">
                        <Link to="/">Remembered it? Log in here</Link>
                    </div>
                </Form>
            </section>
        )
    }
}


// WEBPACK FOOTER //
// ./src/scenes/ResetPassword/view.js